import { Sparkles } from "lucide-react";
import { PRICE_DISPLAY } from "@/utils/tip-odds";

/**
 * Text toggle under a tip list: show its prices as "$ price" or as "odds %".
 * Early Mail prices are Lexi's own odds; Race Day tips / Late Mail are market prices.
 *
 * @param {{ source: "lexi" | "market", mode: string, onToggle: Function }} props
 */
export default function TipPriceToggle({ source, mode, onToggle }) {
  const isPercent = mode === PRICE_DISPLAY.PERCENT;
  return (
    <div className="tip-price-toggle flex items-center justify-end w-full pt-0 pb-1 text-[10px] leading-[1.1] text-gray-500 text-right">
      {source === "lexi" ? (
        <>
          <Sparkles className="w-3 h-3 text-brand-pink mr-1" aria-hidden="true" />
          <span>
            Odds generated by <strong>Lexi</strong>
          </span>
        </>
      ) : (
        <span>Market prices</span>
      )}
      <span className="mx-1" aria-hidden="true">
        ·
      </span>
      <button
        type="button"
        onClick={onToggle}
        className="font-semibold text-brand-pink underline underline-offset-2 cursor-pointer"
        aria-pressed={isPercent}
        data-testid="tip-price-toggle"
      >
        {isPercent ? "Show $ price" : "Show odds %"}
      </button>
    </div>
  );
}
